// @flow
import type { StatelessFunctionalComponent } from 'react';
import styled from 'styled-components';

const NotifWrapper: StatelessFunctionalComponent<*> = styled.div`
  .NotifWrapper {
    &-container {
      flex-direction: column;
      border-bottom: 1px solid #cccaca;
      background-color: var(--white-color);
      padding: 7px 10px 7px 10px;
      margin: 0px;
    }

    &-containerRead {
      flex-direction: column;
      border-bottom: 1px solid #cccaca;
      background-color: #f3f3f3;
      padding: 7px 10px 7px 10px;
      margin: 0px;
    }

    &-item {
      cursor: pointer;

      &:hover {
        background-color: #f9f9f9;
      }
    }

    &-row {
      width: 100%;
      flex-direction: row;
    }

    &-date {
      display: flex;
    }

    &-date2 {
      display: flex;
      color: #b8b6b6;
      text-align: left;
      align-items: flex-start;
      justify-content: flex-start;
      margin: 0px;
      font-size: 1.1em;
    }

    &-id {
      display: flex;
      color: var(--blue-color);
      margin: 0px 5px 0px 5px;
      font-size: 1.1em;
    }

    &-comment {
      display: flex;
      color: var(--text-color-2);
      font-weight: 500;
      font-size: 1.2em;
    }

    &-menu {
      display: flex;
      color: var(--blue-color);
      font-weight: 500;
      font-size: 1.2em;
    }

    &-dot {
      background-color: orange;
      border-radius: 6px;
      width: 12px;
      height: 12px;
      display: flex;
      align-self: right;
      margin-top: 7px;
      margin-left: 170px;
    }
  }
`;

export default NotifWrapper;
